import { render } from "./RdvPedagoP.vue?vue&type=template&id=5ddec34a&scoped=true"
import script from "./RdvPedagoP.vue?vue&type=script&lang=js"
export * from "./RdvPedagoP.vue?vue&type=script&lang=js"

import "./RdvPedagoP.vue?vue&type=style&index=0&id=5ddec34a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddec34a"]])

export default __exports__